import addMount from "../../../core/addMount";
import MaterialGridLinkAutomaticEntry from "./MaterialGridLinkAutomatic.entry";

addMount({
  appName: "material-grid-link-automatic",
  app: MaterialGridLinkAutomaticEntry
});
